import { apiGet, apiPostNoContent } from '@/services/apiClient';
import type { EventDetailsRow, RegistrationRow, RetriggerRegistrationRequest } from '../types';

const CONTROLLER = 'api/EventOData';
const REGISTRATION_CONTROLLER = 'api/Registration';
const WEBHOOK_CONTROLLER = 'api/WebhookReceiver';
const API_VERSION = '1';

interface FetchEventDetailsParams {
  eventCode: string;
  accountCode: string;
}

function getDefaultDateRange() {
  const now = new Date();
  const start = new Date(now);
  start.setDate(now.getDate() - 10);
  const end = new Date(now);
  end.setDate(now.getDate() + 10);
  return { startDate: start, endDate: end };
}

/**
 * Uses the existing EventOData search endpoint and narrows to the selected
 * account/event pair to mirror the selected row from the Events Log grid.
 */
export async function fetchEventDetails({
  eventCode,
  accountCode,
}: FetchEventDetailsParams): Promise<EventDetailsRow | null> {
  const { startDate, endDate } = getDefaultDateRange();
  const qs = new URLSearchParams({
    eventcode: eventCode,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
    searchEvents: '',
    'api-version': API_VERSION,
  });

  const rows = await apiGet<EventDetailsRow[]>(`${CONTROLLER}/GetEventsBySearch?${qs}`);
  return (
    rows.find(
      (row) =>
        row.eventCode.toLowerCase() === eventCode.toLowerCase() &&
        row.accountCode.toLowerCase() === accountCode.toLowerCase(),
    ) ?? null
  );
}

export async function fetchRegistrations({
  eventCode,
  accountCode,
}: FetchEventDetailsParams): Promise<RegistrationRow[]> {
  const qs = new URLSearchParams({
    eventCode,
    accountCode,
    'api-version': API_VERSION,
  });

  return apiGet<RegistrationRow[]>(
    `${REGISTRATION_CONTROLLER}/GetAllRegistrationDetailsByEventCode?${qs}`,
  );
}

export async function retriggerRegistrations(
  request: RetriggerRegistrationRequest[],
): Promise<void> {
  const qs = new URLSearchParams({ 'api-version': API_VERSION });
  await apiPostNoContent<RetriggerRegistrationRequest[]>(
    `${WEBHOOK_CONTROLLER}/RetriggerRegistrationSignalBulk?${qs}`,
    request,
  );
}
